import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthContextProvider, LoaderContext } from "../../AuthContext/AuthContext";
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import "../../Pages/BookPandit/BookPandit.css";
import { t } from "i18next";
import NoResultFoundModel from "../NoDataFound/NoDataFoundModal";
import { AddUpdateRemoveCart, GetProductCategoryLookupList, GetProductCatLookupList } from "../../ApiServices/EStore/EStoreApi";
import HoroscopeBannerImg from "../../assets/images/new/breadcurmp.png";
import Breadcrumbs from "../Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faCalendarAlt, faChevronLeft, faChevronRight, faVihara, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import RatingStars from "./RatingStars";
import LoginPopUp from "../LoginPopup";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet-async";

const MyStore = () => {
  const { isAuthenticated } = useContext(AuthContextProvider);
  const scrollRefs = useRef({});
  const navigate = useNavigate()
  const location = useLocation()
  const user_id = localStorage.getItem("userID");
  const userKeyID = localStorage.getItem("userKeyID");
  const [totalRecords, setTotalRecords] = useState(-1);
  const { setLoader, selectedLanguageID, setIsCartUpdate, isCartUpdate, isLanguageUpdate, formatToIndianCurrency } = useContext(LoaderContext);

  const [isOnlineSelected, setIsOnlineSelected] = useState(false);
  const [productList, setProductList] = useState([]);
  const [categories, setCategories] = useState([])
  const [metaDesc, setMetaDesc] = useState("Shop authentic puja kits, ritual essentials, spiritual gifts & devotional products online. Find everything you need for homams puja & worship at Myomnamo");
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [isCatUpdated, setIsCatUpdated] = useState(false)
  const [loginPopUp, setLoginPopUp] = useState(null);

  localStorage.setItem("previousPath", location.pathname);

  useEffect(() => {
    GetCatLookupListData()

  }, [])

  // useEffect(() => {

  //   if (isCatUpdated) {
  //     if (location?.state?.selectedCat !== null && location?.state?.selectedCat !== undefined && location?.state?.selectedCat !== '') {
  //       setSelectedCategory(location?.state?.selectedCat)
  //       GetProductCatLookupListData(location?.state?.selectedCat)
  //     } else {

  //       setSelectedCategory(categories[0]?.productCatKeyID)
  //       GetProductCatLookupListData(categories[0]?.productCatKeyID)
  //     }
  //     setIsCatUpdated(false)
  //   }
  // }, [isCatUpdated])

  useEffect(() => {
    if (isCatUpdated && categories?.length > 0) {

      const storedCat = localStorage.getItem("productCatKeyID");

      let finalCategory = null;

      if (
        location?.state?.selectedCat !== null &&
        location?.state?.selectedCat !== undefined &&
        location?.state?.selectedCat !== ''
      ) {
        finalCategory = location.state.selectedCat;
      }
      else if (storedCat) {
        finalCategory = storedCat;
      }
      else {
        finalCategory = categories[0]?.productCatKeyID;
      }

      setSelectedCategory(finalCategory);
      GetProductCatLookupListData(finalCategory);

      setIsCatUpdated(false);
    }
  }, [isCatUpdated]);

  useEffect(() => {
    if (isLanguageUpdate) {
      GetCatLookupListData()
      GetProductCatLookupListData(selectedCategory)

    }
  }, [isLanguageUpdate])

  // -------------------API Calling----------------
  const GetCatLookupListData = async () => {

    setLoader(true);
    try {
      const response = await GetProductCategoryLookupList({
        applangID: Number(selectedLanguageID),

      });

      if (response?.statusCode === 200) {
        setLoader(false);
        const list = response?.responseData?.data || []
        const FilteredList = list?.filter((value, index) => value?.productCount > 0)
        setCategories(FilteredList);
        setIsCatUpdated(true)
        setTotalRecords(list?.length);

      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const GetProductCatLookupListData = async (selectedCategory) => {

    setLoader(true);
    try {
      const response = await GetProductCatLookupList(selectedCategory, location?.state?.templeID, Number(selectedLanguageID), userKeyID);

      if (response?.statusCode === 200) {
        const list = response?.responseData?.data
        setProductList(list);
        setTotalRecords(list?.length);
        setLoader(false);
      } else {
        setLoader(false);
        setTotalRecords(0);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  // ----------------------------------Other Functions---------------------------------

  const viewDetail = (product) => {
    const newSlug = product?.productSlug;
    if (selectedCategory) {
      sessionStorage.setItem("selectedProductCatId", selectedCategory);
    }
    navigate(`/product-details/${newSlug}`, {
      state: { product: product, isSubscriptionProductCategory: product?.isSubscriptionProductCategory },
    });
  };



  const handleCatChange = (category) => {
    setTotalRecords(-1)
    setProductList([])
    setSelectedCategory(category?.productCatKeyID);
    localStorage.setItem("productCatKeyID", category?.productCatKeyID)
    sessionStorage.setItem("selectedProductCatId", category?.productCatKeyID);
    GetProductCatLookupListData(category.productCatKeyID)

  };

  const addProduct = async (product, action) => {
    if (!isAuthenticated) {
      setLoginPopUp(true)
    } else {
      setLoader(true);
      try {
        const response = await AddUpdateRemoveCart({
          cartKeyID: product?.cartKeyID,
          productKeyID: product?.productKeyID,
          userKeyID: userKeyID,
          action: action
        });

        if (response?.statusCode === 200) {
          setLoader(false);
          // toast.success("Product Added to cart.")
          setIsCartUpdate(true)
          GetProductCatLookupListData(selectedCategory)

        } else {
          setLoader(false);

        }


      } catch (error) {
        setLoader(false);
        console.log(error);
      }
    }

  }


  return (
    <>
      <Helmet>
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta
          name="description"
          content={metaDesc}
        />

        <meta
          property="og:description"
          content={metaDesc}
        />
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:description"
          content={metaDesc}
        />

      </Helmet>
      <section className="page-header" style={{ paddingBottom: '28px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">{t("E-Store")}</h2>
          <div className="d-flex justify-content-center">
            <Breadcrumbs />
          </div>
        </div>
      </section>
      <div className="container-fluid my-4">
        {/* -------- Mobile View: Horizontal Categories -------- */}
        <fieldset className="border rounded mb-3 d-block d-md-none">
          <legend className="float-none w-auto px-2 fw-bold" style={{ fontSize: "14px" }}>
            {t("categories")}
          </legend>
          <div className="d-block d-md-none">
            <div
              className="d-flex overflow-auto"
              style={{
                whiteSpace: "nowrap",
                scrollbarWidth: "none", // Firefox hide scrollbar
                borderBottom: "1px solid #ddd",
                paddingBottom: "4px",
                gap: "24px",
              }}
            >
              {categories?.map((cat) => (
                <div
                  key={cat?.productCatKeyID}
                  ref={(el) => (scrollRefs.current[cat?.productCatKeyID] = el)}
                  onClick={() => {
                    handleCatChange(cat);

                    // scroll selected category to center
                    const el = scrollRefs.current[cat?.productCatKeyID];
                    if (el) {
                      el.scrollIntoView({
                        behavior: "smooth",
                        inline: "center", // horizontal centering
                        block: "nearest",
                      });
                    }
                  }}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    textTransform: "uppercase",
                    fontWeight: selectedCategory === cat?.productCatKeyID ? "600" : "400",
                    color: selectedCategory === cat?.productCatKeyID ? "#991b3d" : "#000",
                  }}
                >
                  <span>{cat.productCategoryName}</span>

                  {/* underline for active item */}
                  <span
                    style={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: "-4px",
                      height: "2px",
                      backgroundColor: "#991b3d",
                      transform:
                        selectedCategory === cat?.productCatKeyID ? "scaleX(1)" : "scaleX(0)",
                      transformOrigin: "center",
                      transition: "transform 0.25s ease",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

        </fieldset>

        <div className="row">
          {/* -------- Desktop Sidebar -------- */}
          <aside className="col-md-3 d-none d-md-block " >

            <div>
              <h4 className='px-3 pt-3' >{t("Product Category")}</h4>
            </div>
            <hr />
            <div
              className=" p-3"
              style={{ maxHeight: "65vh", overflowY: "auto", scrollbarWidth: "thin" }}
            >

              <ul className="list-unstyled" style={{ cursor: 'pointer' }}>
                {categories?.map((cat, i) => (
                  <li key={cat?.productCatKeyID} className="mb-2" onClick={() => handleCatChange(cat)} style={{ cursor: 'pointer' }}>
                    <label className={`form-check-label small ${selectedCategory === cat?.productCatKeyID ? "activeText" : ''}`} style={{ cursor: 'pointer' }}>
                      <i className="fa fa-angle-right me-2"></i>
                      {cat.productCategoryName}
                    </label>
                  </li>
                ))}
              </ul>
            </div>

          </aside>

          {/* -------- Puja Grid -------- */}
          <main className="col-md-9 col-12 ps-4" >
            <div className="row g-2 mt-1 " style={{ maxHeight: "100vh", overflowY: "auto", scrollbarWidth: "none", justifyContent: 'left' }}>
              {productList?.map((product, index) => (
                <div
                  className="col-xl-4 col-6 col-lg-4 col-md-6 col-sm-6 mb-4 "


                >
                  <div

                    className="card shadow-sm  rounded-3 h-100 border bolder-dark"
                    style={{ cursor: "pointer", overflow: "hidden" }}

                  >
                    {/* Image Section */}
                    <div className="position-relative" onClick={() => viewDetail(product)}>
                      {/* Trending Tag */}
                      {product?.tagName && (
                        <div
                          className="position-absolute top-0 end-0 px-3  text-white fw-bold shadow-sm"
                          style={{
                            background: "linear-gradient(135deg, #f4b722, #ff7e00)",
                            borderBottomLeftRadius: "12px",
                            borderTopRightRadius: "12px",
                            fontSize: "13px",
                            letterSpacing: "0.5px",
                          }}
                        >
                          {product?.tagName}
                        </div>
                      )}

                      {/* Product Image */}
                      <img
                        src={product.productImageURL || pandit}
                        alt={product.productName}
                        className="card-img-top"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = pandit;
                        }}
                        style={{
                          height: "150px",
                          objectFit: "contain",
                          borderTopLeftRadius: "12px",
                          borderTopRightRadius: "12px",
                        }}
                      />
                    </div>


                    {/* Card Body */}
                    <div className="card-body p-2 d-flex flex-column">
                      <h6
                        className="card-title fw-bold mb-1 ps-2"
                        style={{ color: "#8f3246", fontSize: "16px" }}
                      >
                        {product.productName}
                      </h6>

                      {/* <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                                                {product.PUJA_TAGLINE || "A powerful ritual description..."}
                                            </p> */}



                      {/* Price & Button */}
                      <div className="mt-auto">
                        <div className="d-flex justify-content-between">
                          <span
                            className="fw-bold ps-2"
                            style={{ fontSize: "16px", color: "#000" }}
                          >
                            ₹
                            {
                              formatToIndianCurrency(Math.round(product.productPrice - (product.discountAmtount || 0)))

                            }
                          </span>
                          {(product?.rating !== null && product?.rating > 0) && (

                            <RatingStars rating={product?.rating} />
                          )}

                        </div>



                        {product?.cartQuantity > 0 ? (
                          <div
                            className="d-flex justify-content-between align-items-center mt-2 qty-container"

                          >
                            <button
                              onClick={() => addProduct(product, 'Update')}
                              className="product-qty"
                            >
                              −
                            </button>
                            <span
                              className="quantity"
                            >
                              {product.cartQuantity}
                            </span>
                            <button
                              onClick={() => addProduct(product, "Add")}
                              className="product-qty"
                            >
                              +
                            </button>
                          </div>
                        ) : product?.isSubscriptionProductCategory ? (
                          <button
                            className="btn w-100 mt-2 add-to-cart"

                            onClick={() => viewDetail(product)}
                          >
                            <span className="blink-text">

                              {t("View Details")}
                            </span>
                          </button>
                        ) : (
                          <button
                            className="btn w-100 mt-2 add-to-cart"

                            onClick={() => addProduct(product, "Add")}
                          >
                            <span className="blink-text">

                              {t("Add To Cart")}
                            </span>
                          </button>
                        )}




                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {totalRecords <= 0 && <NoResultFoundModel totalRecords={totalRecords} />}
            </div>
          </main>
        </div >
      </div >
      {loginPopUp && (
        <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
      )}
    </>
  );
};

export default MyStore;
